import { map } from "rxjs/operators";
import { GET, POST } from "../../../module/services/fetch";
import { ISecurityQuestionPost } from "../SecurityQuestionsManagement/module/constants";

export const fetchQuestionConfig = () => {
  return GET("authentication/question/configuration").pipe(
    map((response: any) => response)
  );
};

export const fetchSecurityQuestions = () => {
  return GET("authentication/question").pipe(map((response: any) => response));
};

export const postSecurityQuestions = (payload: ISecurityQuestionPost) => {
  return POST("authentication/question", payload).pipe(
    map((response: any) => response)
  );
};

export const fetchSecurityQuestionsLogin = (user: string) => {
  return GET(`authentication/questionUser?userCode=${user}`).pipe(
    map((response: any) => response)
  );
};

export const addMobileService = (body: { otp: string }) => {
  return POST(`authentication/validate-verify-mobile-number`, body).pipe(
    map((response: any) => response)
  );
};

export const validateMobileService = (body: { otp: string }) => {
  return POST(`authentication/validate-verify-mobile-number`, body).pipe(
    map((response: any) => response)
  );
};
